module.exports = __webpack_public_path__ + "static/media/final-solo-marker.30331a85.png";